import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StandardIcon } from 'src/app/models/categoryTree/category-tree';

interface Base64Param { element: string, type: number, i: number}

@Component({
  selector: 'app-selecting-icon-for-widgets',
  templateUrl: './selecting-icon-for-widgets.component.html',
  styleUrls: ['./selecting-icon-for-widgets.component.scss']
})


export class SelectingIconForWidgetsComponent implements OnInit {

  @Input() iconType: StandardIcon = undefined;
  @Input() iconToLoad: string | undefined;
  @Input() standardIcon: boolean | undefined;
  @Output() getPureB64Emit = new EventEmitter<Base64Param>();
  @Output() deleteIcon = new EventEmitter();
  isMax1Mb: boolean = false;

  constructor(
    public _DomSanitizationService: DomSanitizer,
  ) { }

  ngOnInit(): void {
  }

  resetIconToLoad(){
    this.iconToLoad = undefined;
    this.isMax1Mb = false;
  }

  resetAllIcon(){
    // this.categoryToBeMenaged.icon = undefined;
    this.deleteIcon.emit();
    this.resetIconToLoad();
  }

  encodeImageFileAsURL(target, type: number, i?) {
    const element = target.files ? target.files : target;
    var file = element[0];
    if( target?.files ){
      this.isMax1Mb = false;
      if( file?.size <= 1048576) {
        var file = element[0];

        var reader = new FileReader();
        reader.onloadend = () => this.getPureB64(reader.result.toString(), type, i);
        reader.readAsDataURL(file);

      } else {
        this.isMax1Mb = true;
        target.value = '';
      }
    } else {
      this.isMax1Mb = false;
      var reader = new FileReader();
      reader.onloadend = () => this.getPureB64(reader.result.toString(), type, i);
      reader.readAsDataURL(file);
    }
  }
  getPureB64(element: string, type: number, i?: number) {
    this.getPureB64Emit.emit({element: element, type:type, i:i})
  }

}
